export default __webpack_public_path__ + "static/media/button-group-usage.8881d924.svg";